import store from "context/admin_v2/store";

export const setFlashMessage = (message) => store.getActions().app.setFlashMessage({ message });
